import { Component, input } from '@angular/core';
import { BenefitsListComponent } from '../benefits-list/benefits-list.component';
import { BenefitsListItem } from '../benefits-list/models/benefits-list-item.interface';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-benefits-list-additional-items',
  templateUrl: './benefits-list-additional-items.component.html',
  styleUrl: './benefits-list-additional-items.component.scss',
  imports: [BenefitsListComponent, IconComponent],
})
export class BenefitsListAdditionalItemsComponent {
  title = input<string | undefined>(`Plus you'll get`);
  benefitsListAdditionalItems = input<BenefitsListItem[]>([]);
}
